import { useTranslation } from "react-i18next";
import { ParticipantProfile } from "../../../models/entities/participant.model";
import { Dialog } from "primereact/dialog";
import ParticipantDetailExternalLink from "../details/ParticipantDetailExternalLink";
import UiButton from "../../../components/button/Button";

const ModalSurveyLinks = ({
	isVisible,
	participant,
	closeModal,
}: {
	isVisible: boolean;
	participant: ParticipantProfile;
	closeModal: () => void;
}) => {
	const { t } = useTranslation("common");

	return (
		<Dialog
			header={t("PARTICIPANT.SURVEYS.MODAL_LINKS.TITLE")}
			visible={isVisible}
			breakpoints={{ "960px": "75vw", "640px": "100vw" }}
			style={{ width: "70vw" }}
			modal={true}
			focusOnShow={false}
			onHide={closeModal}
		>
			{/* Post-discharge consent link */}
			<ParticipantDetailExternalLink
				href={participant.postDischargeConsentLink}
				title="PARTICIPANT.SURVEYS.MODAL_LINKS.postDischargeConsentLink"
			/>

			{/* Telehealth consent link */}
			<ParticipantDetailExternalLink
				href={participant.telehealthConsentLink}
				title="PARTICIPANT.SURVEYS.MODAL_LINKS.telehealthConsentLink"
			/>

			{/* Pre-visit setup call link */}
			<ParticipantDetailExternalLink
				href={participant.preVisitSetupCallLink}
				title="PARTICIPANT.SURVEYS.MODAL_LINKS.preVisitSetupCallLink"
			/>

			{/* Health risk assessment link */}
			<ParticipantDetailExternalLink
				href={participant.healthRiskAssessmentLink}
				title="PARTICIPANT.SURVEYS.MODAL_LINKS.healthRiskAssessmentLink"
			/>

			{/* DASI (Duke Activity Status Index) link */}
			<ParticipantDetailExternalLink
				href={participant.dasiSurveyLink}
				title="PARTICIPANT.SURVEYS.MODAL_LINKS.dasiLink"
			/>

			{/* Insurance link */}
			<ParticipantDetailExternalLink
				href={participant.insuranceSurveyLink}
				title="PARTICIPANT.SURVEYS.MODAL_LINKS.insuranceLink"
			/>

			{/* Insurance no consent link */}
			<ParticipantDetailExternalLink
				href={participant.insuranceNoConsentLink}
				title="PARTICIPANT.SURVEYS.MODAL_LINKS.insuranceNoConsentLink"
			/>

			{/* Health information release link */}
			<ParticipantDetailExternalLink
				href={participant.hipaaReleaseSurveyLink}
				title="PARTICIPANT.SURVEYS.MODAL_LINKS.hipaaLink"
			/>

			{/* Care gap analysis link */}
			<ParticipantDetailExternalLink
				href={participant.careGapAnalysisLink}
				title="PARTICIPANT.SURVEYS.MODAL_LINKS.careGapAnalysisLink"
			/>

			{/* Financial assistance application link */}
			<ParticipantDetailExternalLink
				href={participant.financialAssistanceApplicationLink}
				title="PARTICIPANT.SURVEYS.MODAL_LINKS.financialAssistanceApplicationLink"
			/>

			{/* RAPID3 link */}
			<ParticipantDetailExternalLink
				href={participant.rapid3SurveyLink}
				title="PARTICIPANT.SURVEYS.MODAL_LINKS.rapid3SurveyLink"
			/>

			{/* Caregiver information link */}
			<ParticipantDetailExternalLink
				href={participant.caregiverInformationLink}
				title="PARTICIPANT.SURVEYS.MODAL_LINKS.caregiverInformationLink"
			/>

			{/* Diabetes pre-education link */}
			<ParticipantDetailExternalLink
				href={participant.diabetesPreEducationLink}
				title="PARTICIPANT.SURVEYS.MODAL_LINKS.diabetesPreEducationLink"
			/>

			{/* Social needs screening tool link */}
			<ParticipantDetailExternalLink
				href={participant.socialNeedsScreeningToolLink}
				title="PARTICIPANT.SURVEYS.MODAL_LINKS.socialNeedsScreeningToolLink"
			/>

			<div className="action-buttons">
				<UiButton
					id="modalBtnClose"
					label="UI_COMPONENTS.BUTTONS.CLOSE"
					className="p-button-outlined p-button-rounded"
					type="button"
					onClick={closeModal}
				></UiButton>
			</div>
		</Dialog>
	);
};

export default ModalSurveyLinks;
